import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Group, Pagination, Select } from '@mantine/core';

interface PaginationRowProps {
  page: number;
  pageLength: number;
  totalPages: number;
  onPageChange: (newPage: number) => void;
  onPageLengthChange: (newPageLength: number) => void;
  pageOptions?: number[];
}

const PaginationRow: FC<PaginationRowProps> = ({
  page,
  pageLength,
  totalPages,
  onPageChange,
  onPageLengthChange,
  pageOptions = [5, 10, 20, 50],
}) => {
  const { t } = useTranslation();

  // ==========================================================================
  // Handlers
  // ==========================================================================
  const handlePageChange = (newPage: number) => {
    onPageChange(newPage);
  };

  const handlePageLengthChange = (newPageLength: number) => {
    onPageLengthChange(newPageLength);
  };

  // ==========================================================================
  // Render
  // ==========================================================================
  return (
    <Group justify="end" align="center" mt="xl">
      <Select
        aria-label={t('common.pagination.itemsPerPage')}
        style={{ width: '4.5em', height: '1.625em !important' }}
        data={pageOptions.map((opt) => opt.toString())}
        value={pageLength.toString()}
        onChange={(value) => handlePageLengthChange(+value!)}
        allowDeselect={false}
      />{' '}
      {totalPages >= 1 && (
        <Pagination
          value={page}
          onChange={handlePageChange}
          total={totalPages}
        />
      )}
    </Group>
  );
};

export default PaginationRow;
